import { select, takeLatest, put, call } from 'redux-saga/effects'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setAssessmentSeq } from '../store/additionalAssessments.actions'
import { setAssessmentSeq as setBodySurveySeq } from '../bodyAssessment/bodySurvey/store/bodySurvey.actions'
import { BodySurveyConstants } from '../bodyAssessment/bodySurvey/store/bodySurvey.constants'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setSequence() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)

  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

  try {
    let sequence = 0
    const bodySurveyAssessments = pcrDoc.additionalAssessment?.bodySurveys

    if (!bodySurveyAssessments || bodySurveyAssessments.length === 0) {
      sequence = 1
    } else {
      const lastBodySurveyRecord = bodySurveyAssessments[bodySurveyAssessments?.length - 1]
      const { seq } = lastBodySurveyRecord
      sequence = seq + 1
    }
    yield put(setAssessmentSeq(sequence))
    yield put(setBodySurveySeq(sequence))
  } catch (e) {
    yield put(throwPcrException(`setSequenceSaga() error: ${e}`))
  }
}

export function* setSequenceSaga() {
  yield takeLatest([BodySurveyConstants.SET_SEQUENCE], performWithMutexHOG, setSequence)
}
